import { useSearchParams, useNavigate } from "react-router-dom";

const PaymentFail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const code = searchParams.get("code") || "";
  const message = searchParams.get("message") || "결제가 취소되었습니다.";

  return (
    <div className="flex items-center justify-center min-h-screen bg-achromatic-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="text-5xl mb-4">😔</div>
        <h2 className="text-xl font-bold text-achromatic-900 mb-2">
          결제 실패
        </h2>
        <p className="text-sm text-achromatic-500 mb-2">{message}</p>
        {code && (
          <p className="text-[11px] text-achromatic-300 mb-6">
            에러 코드: {code}
          </p>
        )}
        <button
          onClick={() => navigate(-1)}
          className="w-full py-3 rounded-xl text-sm font-bold text-white bg-achromatic-700 hover:bg-achromatic-800 transition-colors"
        >
          돌아가기
        </button>
      </div>
    </div>
  );
};

export default PaymentFail;
